const STORAGE_DARK_MODE = 'app.kibun.darkMode'

export let isEnabled = false

export function applyDarkMode (value) {
  isEnabled = value
  const el = document.documentElement
  if (value) {
    el.classList.add('mode-dark')
  } else {
    el.classList.remove('mode-dark')
  }
  localStorage.setItem(STORAGE_DARK_MODE, JSON.stringify(!!value))
}

// LocalStorage to apply instantly

try {
  const storageValue = localStorage.getItem(STORAGE_DARK_MODE)
  if (storageValue) {
    applyDarkMode(JSON.parse(storageValue))
  }
} catch (e) {
  console.error(e)
}
